import { useMemo } from "react";
import { useWindowDimensions } from "react-native";

type Size = {
  width: number;
  height: number;
};
const isOrientationPortrait = ({ width, height }: Size) => height > width;
const isOrientationLandscape = ({ width, height }: Size) => width > height;

export const useDeviceOrientation = () => {
  const screen = useWindowDimensions();
  const portrait = isOrientationPortrait(screen);
  const landscape = isOrientationLandscape(screen);
  return useMemo(() => {
    return {
      portrait,
      landscape,
    };
  }, [portrait, landscape]);
};
